import { type ImageDataType } from '@kk-activity-factory/utils/types/imageDataType';
import { type SearchConfig } from '@kk-activity-factory/search-bar/types/searchConfig';
import { type BtnAction } from './btnAction';
import { type PositionDataType } from '@kk-activity-factory/utils/types/positionDataType';

export enum ShowMoreButtonType {
    None = 0, // 无按钮
    ShowMore = 1, // 查看更多按钮
    flipPage = 2, // 上下翻页按钮
}
export interface StyleDetail {
    moduleBackground: ImageDataType;
    firstRankBackground: ImageDataType;
    secondRankBackground: ImageDataType;
    thirdRankBackground: ImageDataType;
    /**
     * 展示类型
     * 1-TOP3
     * 2-列表
     */
    rankShowType: 1 | 2;
    rankNumText: string;
    rankNumChangeBy: number;
    rankNumChangeBase: number;
    rankColorType?: 1 | 2; // 已废弃 为旧数据保留
    numberColor: string;
    firstRankColor?: string; // 已废弃 为旧数据保留
    secondRankColor?: string; // 已废弃 为旧数据保留
    thirdRankColor?: string; // 已废弃 为旧数据保留
    topicNameColor: string;
    topicNameFontSize?: number;
    topicNameBold?: boolean;
    topicNamePosition?: PositionDataType;
    rankNumColor: string;
    unitColor: string;
    showAvatar: boolean;
    avatarBorderColor: string;
    firstRankImg: ImageDataType;
    secondRankImg: ImageDataType;
    thirdRankImg: ImageDataType;
    startShowRank?: number;
    rankShowNumber: number;
    showMoreButton: boolean; // 已废弃 为旧数据保留
    showMoreButtonType?: ShowMoreButtonType;
    moreButton: ImageDataType;
    showRankNumLimit?: number;
    supportSearch: boolean;
    searchConfig: SearchConfig;
    searchLabelColor: string;
    searchTextColor: string;
    searchTarget: string;
    buttonNumber: 0 | 1 | 2;
    buttonActions: Array<BtnAction>;
    styleVersion?: number;
    topicCoverWidth?: number;
    topicCoverHeight?: number;
    topicCoverPosition?: PositionDataType;
    topicCoverRadiusLeftTop?: number;
    topicCoverRadiusRightTop?: number;
    topicCoverRadiusLeftBottom?: number;
    topicCoverRadiusRightBottom?: number;
    rankNumTextFontSize?: number;
    rankNumTextBold?: boolean;
    rankNumTextPosition?: PositionDataType;
    isShowRecommendReason?: boolean;
    recommendReasonPosition?: PositionDataType;
    recommendReasonColor?: string;
    recommendReasonFontSize?: number;
    isRecommendReasonFontBold?: boolean;
    recommendReasonLineMaxWidth?: number;
    avatarBorderWidth?: number;
    avatarWidth?: number;
    avatarStyleConfigList?: Array<{ position: PositionDataType }>;
    firstRankTagImg?: ImageDataType;
    secondRankTagImg?: ImageDataType;
    thirdRankTagImg?: ImageDataType;
    topThreeRankTagPosition?: PositionDataType;
    rankTagPosition?: PositionDataType;
    rankTagFontSize?: number;
    rankTagHeight?: number;
    rankTagFontBold?: boolean;
    rankTagTextColor?: string;
    rankTagColor?: string;
    rankTagRadiusLeftTop?: number;
    rankTagRadiusRightTop?: number;
    rankTagRadiusLeftBottom?: number;
    rankTagRadiusRightBottom?: number;
    searchTargetPosition?: PositionDataType;
    searchTagImg?: ImageDataType;

    throwCoinNoticeBG: ImageDataType;
    throwCoinNoticeBtnImg: ImageDataType;
    throwCoinNoticeBtnPosition: PositionDataType;
    throwCoinNoticeFontSize: number;
    throwCoinNoticeMaxWidth: number;
    throwCoinNoticeFontBold: boolean;
    throwCoinNoticeTextColor: string;
    throwCoinNoticeXColor: string;
    throwCoinNoticeYColor: string;
    throwCoinNoticeTextPosition: PositionDataType;

    hasSearchTargetLabel: boolean | undefined;

    pageBtnBackground: ImageDataType;
    lastPageBtnImg: ImageDataType;
    lastPageBtnDisableImg: ImageDataType;
    lastPagePosition: PositionDataType;
    nextPageBtnImg: ImageDataType;
    nextPageBtnDisableImg: ImageDataType;
    nextPagePosition: PositionDataType;
}
